// export interface DepartmentState {
//   departments: DepartmentDto[];
//   loading: boolean;
//   error: string | null;
//   selectedDepartment: DepartmentDto | null;
// }

/** Hibrit çalışanların saha modu talepleri: otomatik onay veya onay gerekli */
export type FieldModeApprovalMode = 'auto' | 'approval';
/** Çalışanın açtığı saha aktivitesi: otomatik / hepsi onaylı / seçili türler onaylı */
export type ActivityApprovalMode = 'auto' | 'all' | 'selected';
/** 'VEHICLE' = araç kullanılan aktiviteler */
export type ActivityApprovalType = 'VISIT' | 'DELIVERY' | 'MAINTENANCE' | 'OTHER' | 'OFFICE' | 'VEHICLE';

export interface DepartmentApprovalSettings {
  fieldModeApprovalMode?: FieldModeApprovalMode;
  activityApprovalMode?: ActivityApprovalMode;
  activityApprovalTypes?: ActivityApprovalType[];
}

export interface DepartmentDto extends DepartmentApprovalSettings {
  id: number;
  name: string;
  isActive: boolean;
  status: DepartmentStatus;
  createdAt: string;
  updatedAt: string;
  employeeCount: number;
  
  // Zorunlu alanlar (lateTolerationMinutes hariç)
  fixedShiftStartTime: string;
  fixedShiftEndTime: string;
  fixedShiftDays: string[] | string; // Backend'den string gelir, frontend'de array'e çevrilir
  lateTolerance: boolean;
  lateTolerationMinutes?: number; // Sadece bu opsiyonel
  defaultBreakDuration: number;
  maxBreakDuration: number;
  maxMealBreakDuration?: number; // Yeni eklendi: Yemek molası limiti
  overtimeRequestEnabled?: boolean | number; // Yeni eklendi: Manuel fazla mesai talep sistemi aktif mi? (Backend'den 0/1 olarak gelebilir)
}

export interface DepartmentCreateDTO extends DepartmentApprovalSettings {
  name: string;
  status?: DepartmentStatus;
  
  // Zorunlu alanlar (lateTolerationMinutes hariç)
  fixedShiftStartTime: string;
  fixedShiftEndTime: string;
  fixedShiftDays: string[] | string; // Frontend'den array gelir, backend'e string gönderilir
  lateTolerance: boolean;
  lateTolerationMinutes?: number; // Sadece bu opsiyonel
  defaultBreakDuration: number;
  maxBreakDuration: number;
  maxMealBreakDuration?: number; // Yeni eklendi: Yemek molası limiti
  overtimeRequestEnabled?: boolean | number; // Yeni eklendi: Manuel fazla mesai talep sistemi (Backend'den 0/1 olarak gelebilir)
}

export interface DepartmentUpdateDTO extends DepartmentCreateDTO {
  id: number;
  isActive?: boolean;
}

export interface UpdateDepartmentDto extends DepartmentApprovalSettings {
  name?: string;
  isActive?: boolean;
  fixedShiftStartTime?: string;
  fixedShiftEndTime?: string;
  fixedShiftDays?: string[];
  lateTolerance?: boolean;
  lateTolerationMinutes?: number;
  defaultBreakDuration?: number;
  maxBreakDuration?: number;
  maxMealBreakDuration?: number; // Yeni eklendi: Yemek molası limiti
  overtimeRequestEnabled?: boolean | number; // Yeni eklendi: Manuel fazla mesai talep sistemi (Backend'den 0/1 olarak gelebilir)
  status?: 'active' | 'inactive' | 'deleted';
}

export enum DepartmentStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
  DELETED = "deleted"
}

export interface LeaveApprover {
  id: number;
  firstName: string;
  lastName: string;
}

export interface LeaveApprovalStep {
  id: number;
  stepOrder: number;
  approver: LeaveApprover;
}

export interface LeaveApprovalHierarchy {
  id: number;
  createdAt: string;
  updatedAt: string;
  steps: LeaveApprovalStep[];
}

export interface HierarchyStepPayload {
  approverId: number;
  stepOrder: number;
}
